<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="cs_wrapper">
  <div *ngIf="!isShared" class="row">
    <div class="col-lg-12 mt-1 mb-2">
      <div class="float-right d-none d-lg-block">
        <a href="javascript:void(0)" (click)="onCopyLink()" class="btn btn-sm btn-primary ml-2"> Shareable Link </a>
      </div>
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <td>
          <div class="cs_header">
            <div class="cs_list">
              <div class="cs_list-item">
                <span class="cs_hl">Name:</span> {{comparisonModel.newerRunningReport.user.firstName}} {{comparisonModel.newerRunningReport.user.lastName}}
              </div>
              <div class="cs_list-item">
                <span class="cs_hl">Date:</span> {{comparisonModel.newerRunningReport.reportDate | date:'short' }}
              </div>
            </div>
            <a href="https://rundna.com/" target="_blank"><img class="cs_logo" src="../../../../assets/img/gaitreport/logo.png" alt="logo" /> </a>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="card card-body">
            <div class="cs_panel cs_rrp">
              <div class="cs_highlight-bg"></div>

              <div class="cs_stats-wrapper cs_gap-lg">
                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col" style="align-items:start; margin-top: 1.5em;">
                    <h2 class="text-center cs_bold">
                      RunDNA<br>Running Score
                    </h2>
                  </div>

                  <div class="cs_stats-col cs_gap-3 to-center" style="margin-top: 0.5em;">
                    <div style="width:100%">
                      <div class="text-center main_header_cs ws-wrap">
                        <div *ngIf="!isShared" class="cs_bold" style="line-height: 1.1em;"> <a target="_blank" href="javascript:void(0)" [routerLink]="[assessmentsUrl, comparisonModel.olderRunningReport.id]">{{ (comparisonModel.olderRunningReport.name.length > 50) ? (comparisonModel.olderRunningReport.name | slice:0:50) + '...' : (comparisonModel.olderRunningReport.name) }}</a> </div>
                        <div *ngIf="isShared" class="cs_bold" style="line-height: 1.1em;"> {{ (comparisonModel.olderRunningReport.name.length > 50) ? (comparisonModel.olderRunningReport.name | slice:0:50) + '...' : (comparisonModel.olderRunningReport.name) }} </div>
                        <div class="report_name"> {{ comparisonModel.olderRunningReport.reportDate  | date:'longDate'}} </div>
                        <div class="speed_section"> Speed {{comparisonModel.olderRunningReport.speed | number:'1.2-2' }} {{comparisonModel.olderRunningReport.speedUnit | enumString: speedUnitEnum}} </div>
                      </div>
                    </div>
                    <div class="cs_scrore_overal_container">
                      <div class="cs_scrore_overal_item_label cs_scrore_overal_item_label_position_{{ comparisonModel.olderRunningReport.runningAnalysisReportScoreDescription }}"> {{comparisonModel.olderRunningReport.runningScore}} &#9654; </div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-1"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-2"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-3"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-4"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-5"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-6"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-7"></div>
                      <div *ngIf="comparisonModel.olderRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-8"></div>
                    </div>
                  </div>
                  <div class="cs_stats-col cs_gap-3 to-center" style="padding-left:1.5em; margin-top: 0.5em;">
                    <div class="cs_scrore_overal_container">
                      <div class="cs_scrore_overal_item_label_right cs_scrore_overal_item_label_position_{{ comparisonModel.newerRunningReport.runningAnalysisReportScoreDescription }}">&#9664; {{comparisonModel.newerRunningReport.runningScore}}</div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-1"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-2"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-3"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-4"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-5"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-6"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-7"></div>
                      <div *ngIf="comparisonModel.newerRunningReport.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-8"></div>
                    </div>
                    <div style="width: 100%; margin-left: 2.0em;">
                      <div class=" text-center main_header_cs ws-wrap">
                        <div class="cs_bold" style="line-height:1.1em;" *ngIf="!isShared"> <a target="_blank" href="javascript:void(0)" [routerLink]="[assessmentsUrl, comparisonModel.newerRunningReport.id]">{{ (comparisonModel.newerRunningReport.name.length > 50) ? (comparisonModel.newerRunningReport.name | slice:0:50) + '...' : (comparisonModel.newerRunningReport.name) }}</a></div>
                        <div class="cs_bold" style="line-height:1.1em;" *ngIf="isShared"> {{ (comparisonModel.newerRunningReport.name.length > 50) ? (comparisonModel.newerRunningReport.name | slice:0:50) + '...' : (comparisonModel.newerRunningReport.name) }} </div>
                        <div class="report_name"> {{ comparisonModel.newerRunningReport.reportDate  | date:'longDate' }} </div>
                        <div class="speed_section"> Speed {{comparisonModel.newerRunningReport.speed | number:'1.2-2' }} {{comparisonModel.newerRunningReport.speedUnit | enumString: speedUnitEnum}} </div>
                      </div>
                    </div>
                  </div>
                  </div>

                <img src="../../../../assets/img/runningreport/human.png" alt="image" class="cs_image_001" />


                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col max_w_5">
                    <h3 class="cs_bold">General Form</h3>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.generalForm.left | enumString: categoryScoreEnum | lowercase }}">
                      {{comparisonModel.olderRunningReport.generalForm.left | enumString: categoryScoreEnum}}
                      <div class="cs_stats-col-label text-underline">Left</div>
                    </div>
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.generalForm.right | enumString: categoryScoreEnum | lowercase }}">
                      {{comparisonModel.olderRunningReport.generalForm.right | enumString: categoryScoreEnum}}
                      <div class="cs_stats-col-label text-underline">Right</div>
                    </div>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.generalForm.left | enumString: categoryScoreEnum | lowercase }}">
                      {{comparisonModel.newerRunningReport.generalForm.left | enumString: categoryScoreEnum}}
                      <div class="cs_stats-col-label text-underline">Left</div>
                    </div>
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.generalForm.right | enumString: categoryScoreEnum | lowercase }}">
                      {{comparisonModel.newerRunningReport.generalForm.right | enumString: categoryScoreEnum}}
                      <div class="cs_stats-col-label text-underline">Right</div>
                    </div>
                  </div>
                </div>
                <div class="cs_separator"></div>
                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col max_w_5">
                    <h3 class="cs_bold">Pelvis</h3>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.pelvis.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.pelvis.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.pelvis.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.pelvis.right | enumString: categoryScoreEnum}}</div>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.pelvis.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.pelvis.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.pelvis.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.pelvis.right | enumString: categoryScoreEnum}}</div>
                  </div>
                </div>
                <div class="cs_separator"></div>
                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col max_w_5">
                    <h3 class="cs_bold">Hips</h3>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.hip.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.hip.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.hip.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.hip.right | enumString: categoryScoreEnum}}</div>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.hip.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.hip.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.hip.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.hip.right | enumString: categoryScoreEnum}}</div>
                  </div>
                </div>
                <div class="cs_separator"></div>
                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col max_w_5">
                    <h3 class="cs_bold">Knees</h3>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.knee.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.knee.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.knee.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.knee.right | enumString: categoryScoreEnum}}</div>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.knee.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.knee.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.knee.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.knee.right | enumString: categoryScoreEnum}}</div>
                  </div>
                </div>
                <div class="cs_separator"></div>
                <!--  -->
                <div class="cs_stats-row fillx3">
                  <div class="cs_stats-col max_w_5">
                    <h3 class="cs_bold">Ankle</h3>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.foot.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.foot.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.olderRunningReport.foot.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.foot.right | enumString: categoryScoreEnum}}</div>
                  </div>
                  <div class="cs_stats-col cs_gap-md to-center">
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.foot.left | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.foot.left | enumString: categoryScoreEnum}}</div>
                    <div class="cs_score s-{{ comparisonModel.newerRunningReport.foot.right | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.foot.right | enumString: categoryScoreEnum}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->

            <div class="cs_panel cs_rrp cs_mt1">
              <div class="cs_highlight-bg"></div>

              <!--<div class="cs_stats-col cs_mb1">
                <h3 class="gen_par_section">GENERAL PARAMETERS</h3>
              </div>-->

              <div class="cs_stats-wrapper cs_gap-lg">
                <div class="cs_stats-wrapper cs_gap-sm">
                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5" >
                      <h4 class="font-weight-600">
                        Cadence
                      </h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.cadence.value | number:'1.0-0'}} spm</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.cadence.score | enumString: categoryScoreEnum}}</div>
                      <span class="cs_force-fill text-left">&nbsp;</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.cadence.value | number:'1.0-0'}} spm</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.cadence.score | enumString: categoryScoreEnum}}</div>
                      <span class="cs_force-fill text-left">&nbsp;</span>
                    </div>
                  </div>

                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5">
                      <h4 class="font-weight-600">
                        Vertical Oscillation
                      </h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.verticalOscillation.value | number:'1.0-0' }} spm</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.olderRunningReport.verticalOscillation.score | enumString: categoryScoreEnum}}</div>
                      <span class="cs_force-fill text-left">&nbsp;</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.verticalOscillation.value | number:'1.0-0'}} spm</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{comparisonModel.newerRunningReport.verticalOscillation.score | enumString: categoryScoreEnum}}</div>
                      <span class="cs_force-fill text-left">&nbsp;</span>
                    </div>
                  </div>
                </div>
                <div class="cs_separator cs_mb1"></div>
                <div class="cs_stats-wrapper cs_gap-sm">
                  <div class="cs_stats-row">
                  </div>
                  <!--  -->
                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5">
                      <h4 class="font-weight-600">Ground Contact</h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.groundContact.left| number:'1.0-0'}} ms</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.groundContact.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.groundContact.leftScore | enumString: categoryScoreEnum}}
                        <div class="cs_stats-col-label text-underline">Left</div>
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.groundContact.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.groundContact.rightScore | enumString: categoryScoreEnum}}
                        <div class="cs_stats-col-label text-underline">Right</div>
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.olderRunningReport.groundContact.right| number:'1.0-0'}} ms</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.groundContact.left| number:'1.0-0'}} ms</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.groundContact.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.groundContact.leftScore | enumString: categoryScoreEnum}}
                        <div class="cs_stats-col-label text-underline">Left</div>
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.groundContact.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.groundContact.rightScore | enumString: categoryScoreEnum}}
                        <div class="cs_stats-col-label text-underline">Right</div>
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.newerRunningReport.groundContact.right| number:'1.0-0'}} ms</span>
                    </div>
                  </div>
                  <!--  -->
                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5">
                      <h4 class="font-weight-600">Front Side Stance</h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.frontSideStance.left| number:'1.0-0'}} %</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.frontSideStance.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.frontSideStance.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.frontSideStance.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.frontSideStance.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.olderRunningReport.frontSideStance.right| number:'1.0-0'}} %</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.frontSideStance.left| number:'1.0-0'}} %</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.frontSideStance.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.frontSideStance.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.frontSideStance.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.frontSideStance.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.newerRunningReport.frontSideStance.right| number:'1.0-0'}} %</span>
                    </div>
                  </div>

                  <!--  -->
                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5">
                      <h4 class="font-weight-600">Duty Factor</h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.dutyFactor.left| number:'1.0-0'}} %</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.dutyFactor.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.dutyFactor.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.dutyFactor.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.dutyFactor.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.olderRunningReport.dutyFactor.right| number:'1.0-0'}} %</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.dutyFactor.left| number:'1.0-0'}} %</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.dutyFactor.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.dutyFactor.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.dutyFactor.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.dutyFactor.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.newerRunningReport.dutyFactor.right | number:'1.0-0'}} %</span>
                    </div>
                  </div>
                  <!--  -->
                  <div class="cs_stats-row fillx3">
                    <div class="cs_stats-col max_w_5">
                      <h4 class="font-weight-600">Leg Stiffness</h4>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.olderRunningReport.legStiffness.left | number:'1.2-2'}} kN/m</span>
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.legStiffness.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.legStiffness.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.olderRunningReport.legStiffness.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.olderRunningReport.legStiffness.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.olderRunningReport.legStiffness.right | number:'1.2-2'}} kN/m</span>
                    </div>
                    <div class="cs_stats-col cs_gap-sm to-center">
                      <span class="cs_force-fill text-right">{{comparisonModel.newerRunningReport.legStiffness.left | number:'1.2-2'}} kN/m</span>
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.legStiffness.leftScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.legStiffness.leftScore | enumString: categoryScoreEnum}}
                      </div>
                      &nbsp;
                      <div class="cs_score sm s-{{ comparisonModel.newerRunningReport.legStiffness.rightScore | enumString: categoryScoreEnum | lowercase }}">
                        {{comparisonModel.newerRunningReport.legStiffness.rightScore | enumString: categoryScoreEnum}}
                      </div>
                      <span class="cs_force-fill text-left">{{comparisonModel.newerRunningReport.legStiffness.right | number:'1.2-2'}} kN/m</span>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </div>
            </div>

            <!--  -->
            <div class="cs_panel_sm_padding rbg cs_rrp">
              <div class="cs_stats-row fillx3" style="grid-template-columns: 0.7fr 1fr 1fr;">
                <div class="cs_stats-col">
                  <h3 class="cs_bold cs_emp_space_2">Runner Category</h3>
                </div>
                <div class="cs_stats-col to-start" >
                  <div class="cs_highlight cs_w-80">{{comparisonModel.olderRunningReport.categoryRaw}}</div>
                </div>
                <div class="cs_stats-col to-center">
                  <div class="cs_highlight cs_w-80">{{comparisonModel.newerRunningReport.categoryRaw}}</div>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="cs_panel_sm_padding rbg cs_rrp">
              <div class="cs_stats-row fillx3 " style="grid-template-columns: 0.7fr 1fr 1fr;">
                <div class="cs_stats-col">
                  <h3 class="cs_bold cs_emp_space_2">Primary Factor</h3>
                </div>
                <div class="cs_stats-col to-start">
                  <div class="cs_highlight cs_w-80">{{comparisonModel.olderRunningReport.primaryFactorRaw}}</div>
                </div>
                <div class="cs_stats-col to-center">
                  <div class="cs_highlight cs_w-80">{{comparisonModel.newerRunningReport.primaryFactorRaw}}</div>
                </div>
              </div>
            </div>
            <!--  -->

            <div class="cs_score-tab cs_mt1">
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Excellent
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score s-e">e</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Good
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-g">g</div>
                  <div class="cs_score  s-gf">gf</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Fair
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-fg">fg</div>
                  <div class="cs_score  s-f">f</div>
                  <div class="cs_score  s-fp">fp</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Poor
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-pf">pf</div>
                  <div class="cs_score  s-p">p</div>
                </div>
              </div>
            </div>
          </div>

          <hr class="cs_page-break" />


          <!-- page 2 -->

          <div class="card card-body">
            <div class="cs_short-box cs_mt2">
              <h1 class="text-center">Scoring Factors</h1>
              <p class="text-distributed">Below you will find the individual factors that contribute to your RunDNA Running Score.
              Each factor has an “Improvement Index” defining how each metric has changed relative to ideal form.
              A positive index indicates improvement (up to 100%, which is ideal), 0 means the distance from ideal hasn’t changed, and a negative index means it’s moved further away.
              A large negative index may suggest the initial value was already close to the ideal.</p>
            </div>

            <h3 class="text-center factor_section">GENERAL PARAMETERS</h3>
            <div class="cs_separator_gray"></div>

            <div class="cs_pbar-wrapper">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">Cadence</h3>
                  <span class="cs_middle"> {{comparisonModel.cadence.differencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(140, 210, comparisonModel.newerRunningReport.cadence.avgValue, comparisonModel.newerRunningReport.cadence.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml pos-1">
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(140, 210, comparisonModel.newerRunningReport.cadence.avgValue, comparisonModel.newerRunningReport.cadence.stDevValue, comparisonModel.newerRunningReport.cadence.deviationPoints)}}%">
                    <span> {{comparisonModel.newerRunningReport.cadence.rawValue}} </span>
                    <span>&#9650;</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">140</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">210</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Cadence is the number of steps per minute you take measured in steps per minute (spm). There is no ideal cadence, but slower cadences have been linked to certain injuries.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">Vertical Oscillation</h3>
                  <span class="cs_middle"> {{comparisonModel.verticalOscillation.differencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(4, 15, comparisonModel.newerRunningReport.verticalOscillation.avgValue, comparisonModel.newerRunningReport.verticalOscillation.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml pos-1">
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(4, 15, comparisonModel.newerRunningReport.verticalOscillation.avgValue, comparisonModel.newerRunningReport.verticalOscillation.stDevValue, comparisonModel.newerRunningReport.verticalOscillation.deviationPoints)}}%">
                    <span> {{comparisonModel.newerRunningReport.verticalOscillation.rawValue}} </span>
                    <span>&#9650;</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">4</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Vertical oscillation is the amount of motion spent going up and down measured in centimeters (cm). Focusing your energy on running forward rather than up and down helps with injuries and performance.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Ground Contact Time
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.groundContact.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.groundContact.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(100, 350, comparisonModel.newerRunningReport.groundContact.avgValue, comparisonModel.newerRunningReport.groundContact.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(100, 350, comparisonModel.newerRunningReport.groundContact.avgValue, comparisonModel.newerRunningReport.groundContact.stDevValue, comparisonModel.newerRunningReport.groundContact.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.groundContact.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(100, 350, comparisonModel.newerRunningReport.groundContact.avgValue, comparisonModel.newerRunningReport.groundContact.stDevValue, comparisonModel.newerRunningReport.groundContact.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.groundContact.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">100</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">350</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Ground contact time is the time spent with your foot on the ground measured in milliseconds (ms). Minimizing the time spent on the ground helps with decreasing injuries and improving performance.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Front Side Stance
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.frontSideStance.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.frontSideStance.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(10, 60, comparisonModel.newerRunningReport.frontSideStance.avgValue, comparisonModel.newerRunningReport.frontSideStance.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(10, 60, comparisonModel.newerRunningReport.frontSideStance.avgValue, comparisonModel.newerRunningReport.frontSideStance.stDevValue, comparisonModel.newerRunningReport.frontSideStance.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.frontSideStance.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(10, 60, comparisonModel.newerRunningReport.frontSideStance.avgValue, comparisonModel.newerRunningReport.frontSideStance.stDevValue, comparisonModel.newerRunningReport.frontSideStance.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.frontSideStance.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">10</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Front side stance is the percentage of stance phase that happens in front of your center of mass. Higher front side stance can indicate additional braking and slowing.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Duty Factor
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.dutyFactor.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.dutyFactor.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(10, 60, comparisonModel.newerRunningReport.dutyFactor.avgValue, comparisonModel.newerRunningReport.dutyFactor.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(10, 60, comparisonModel.newerRunningReport.dutyFactor.avgValue, comparisonModel.newerRunningReport.dutyFactor.stDevValue, comparisonModel.newerRunningReport.dutyFactor.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.dutyFactor.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(10, 60, comparisonModel.newerRunningReport.dutyFactor.avgValue, comparisonModel.newerRunningReport.dutyFactor.stDevValue, comparisonModel.newerRunningReport.dutyFactor.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.dutyFactor.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">10</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Duty factor is the percentage of time spent on the ground (stance) versus the percentage of time spent in the air (swing). A lower value is desirable and it is beneficial to have similar duty cycle values across different speeds.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Leg Stiffness
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.legStiffness.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.legStiffness.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(5, 30, comparisonModel.newerRunningReport.legStiffness.avgValue, comparisonModel.newerRunningReport.legStiffness.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(5, 30, comparisonModel.newerRunningReport.legStiffness.avgValue, comparisonModel.newerRunningReport.legStiffness.stDevValue, comparisonModel.newerRunningReport.legStiffness.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.legStiffness.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(5, 30, comparisonModel.newerRunningReport.legStiffness.avgValue, comparisonModel.newerRunningReport.legStiffness.stDevValue, comparisonModel.newerRunningReport.legStiffness.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.legStiffness.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">5</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">30</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Leg stiffness is a measure of how “springy” your leg is while running. Higher stiffness means that your body goes through less motion and lower stiffness means your body goes through more motion.
                From a performance standpoint, higher stiffness can mean improved performance.
                Asymmetrical stiffness may indicate past or future injury.
              </p>
            </div>

            <!--  -->

          </div>


          <hr class="cs_page-break" />
          <!-- page 3 -->
          <div class="card card-body">

            <h3 class="text-center factor_section">INITIAL CONTACT</h3>
            <div class="cs_separator_gray"></div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Tibial Inclination
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.tibialInclination.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.tibialInclination.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-10, 10, comparisonModel.newerRunningReport.tibialInclination.avgValue, comparisonModel.newerRunningReport.tibialInclination.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-10, 10, comparisonModel.newerRunningReport.tibialInclination.avgValue, comparisonModel.newerRunningReport.tibialInclination.stDevValue, comparisonModel.newerRunningReport.tibialInclination.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.tibialInclination.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-10, 10, comparisonModel.newerRunningReport.tibialInclination.avgValue, comparisonModel.newerRunningReport.tibialInclination.stDevValue, comparisonModel.newerRunningReport.tibialInclination.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.tibialInclination.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-10</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">10</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Extension (º)</div>
              <div class="cs_bpar-mark-right">Flexion (º)</div>
              <p class="cs_pbar_description after_annotation">
                Tibial inclination is the angle of your shin bone in relationship to the ground.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Foot Inclination
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.footInclination.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.footInclination.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-40, 40, comparisonModel.newerRunningReport.footInclination.avgValue, comparisonModel.newerRunningReport.footInclination.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-40, 40, comparisonModel.newerRunningReport.footInclination.avgValue, comparisonModel.newerRunningReport.footInclination.stDevValue, comparisonModel.newerRunningReport.footInclination.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.footInclination.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-40, 40, comparisonModel.newerRunningReport.footInclination.avgValue, comparisonModel.newerRunningReport.footInclination.stDevValue, comparisonModel.newerRunningReport.footInclination.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.footInclination.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-40</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">40</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Dorsiflexion (º)</div>
              <div class="cs_bpar-mark-right">Plantarflexion (º)</div>
              <p class="cs_pbar_description after_annotation">
                Foot inclination is the angle of your foot in relationship to the ground.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Strike from COM
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.strikeCOM.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.strikeCOM.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(15, 45, comparisonModel.newerRunningReport.strikeCOM.avgValue, comparisonModel.newerRunningReport.strikeCOM.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(15, 45, comparisonModel.newerRunningReport.strikeCOM.avgValue, comparisonModel.newerRunningReport.strikeCOM.stDevValue, comparisonModel.newerRunningReport.strikeCOM.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.strikeCOM.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(15, 45, comparisonModel.newerRunningReport.strikeCOM.avgValue, comparisonModel.newerRunningReport.strikeCOM.stDevValue, comparisonModel.newerRunningReport.strikeCOM.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.strikeCOM.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">15</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">45</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Strike from center of mass (COM) is the distance from your center of mass to where your foot hits the ground. It is a measure that is related to the forces going through your lower body.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Crossover
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.crossover.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.crossover.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 25, comparisonModel.newerRunningReport.crossover.avgValue, comparisonModel.newerRunningReport.crossover.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 25, comparisonModel.newerRunningReport.crossover.avgValue, comparisonModel.newerRunningReport.crossover.stDevValue, comparisonModel.newerRunningReport.crossover.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.crossover.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 25, comparisonModel.newerRunningReport.crossover.avgValue, comparisonModel.newerRunningReport.crossover.stDevValue, comparisonModel.newerRunningReport.crossover.deviationPointsRight)}}%">
                    <span>{{comparisonModel.olderRunningReport.crossover.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">25</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Adduction (cm)</div>
              <div class="cs_bpar-mark-right">Abduction (cm)</div>
              <p class="cs_pbar_description after_annotation">
                Crossover describes the position of the foot at initial contact relative to the midline of your body.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper" style="padding-top:0px;">
              <div class="cs_pbar-item min_height_3">
                <div class="cs_pbar-val-white">
                  <h3 class="cs_pbar-lable-fs">
                    Foot Strike
                  </h3>
                </div>
                <div class="foot_strike_section">
                  <div style="margin-right: 6em;">
                    <span class="foot_strike_label">Left:</span> <span class="foot_strike_value">{{comparisonModel.olderRunningReport.footStrikeLeft | enumString: footStrikeEnum}} &#x2192; {{comparisonModel.newerRunningReport.footStrikeLeft | enumString: footStrikeEnum}}</span>
                  </div>
                  <div>
                    <span class="foot_strike_label">Right:</span> <span class="foot_strike_value">{{comparisonModel.olderRunningReport.footStrikeRight | enumString: footStrikeEnum}} &#x2192; {{comparisonModel.newerRunningReport.footStrikeRight | enumString: footStrikeEnum}}</span>
                  </div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Foot strike describes the portion of the foot which hits the ground at initial contact. Rearfoot strike means that you land on your heel. Non-rearfoot strike means that you land on the middle or front of your foot.
              </p>
            </div>
            <!--  -->
          </div>


          <hr class="cs_page-break" />
          <!-- page 4 -->
          <div class="card card-body">
            <!--  -->
            <h3 class="text-center factor_section">STANCE</h3>
            <div class="cs_separator_gray"></div>
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Ankle
                    Dorsiflexion
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakAnkleDorsiflexion.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakAnkleDorsiflexion.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-40, 20, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.avgValue, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-40, 20, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.avgValue, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.stDevValue, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakAnkleDorsiflexion.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-40, 20, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.avgValue, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.stDevValue, comparisonModel.newerRunningReport.peakAnkleDorsiflexion.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakAnkleDorsiflexion.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-40</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Dorsiflexion (º)</div>
              <div class="cs_bpar-mark-right">Plantarflexion (º)</div>
              <p class="cs_pbar_description after_annotation">
                Peak ankle dorsiflexion is the amount of motion occuring at the ankle during stance phase that contributes to force absorption.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Ankle Pronation
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakAnklePronation.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakAnklePronation.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-5, 15, comparisonModel.newerRunningReport.peakAnklePronation.avgValue, comparisonModel.newerRunningReport.peakAnklePronation.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-5, 15, comparisonModel.newerRunningReport.peakAnklePronation.avgValue, comparisonModel.newerRunningReport.peakAnklePronation.stDevValue, comparisonModel.newerRunningReport.peakAnklePronation.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakAnklePronation.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-5, 15, comparisonModel.newerRunningReport.peakAnklePronation.avgValue, comparisonModel.newerRunningReport.peakAnklePronation.stDevValue, comparisonModel.newerRunningReport.peakAnklePronation.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakAnklePronation.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-5</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Supination (º)</div>
              <div class="cs_bpar-mark-right">Pronation (º)</div>
              <p class="cs_pbar_description after_annotation">
                Peak ankle pronation is the maximum inward rolling motion of the foot during stance phase.
                Pronation is a normal part of running. When we pronate, it allows our foot to come in contact with the ground and absorb forces.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Knee Flexion
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakKneeFlexion.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakKneeFlexion.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 60, comparisonModel.newerRunningReport.peakKneeFlexion.avgValue, comparisonModel.newerRunningReport.peakKneeFlexion.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 60, comparisonModel.newerRunningReport.peakKneeFlexion.avgValue, comparisonModel.newerRunningReport.peakKneeFlexion.stDevValue, comparisonModel.newerRunningReport.peakKneeFlexion.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakKneeFlexion.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 60, comparisonModel.newerRunningReport.peakKneeFlexion.avgValue, comparisonModel.newerRunningReport.peakKneeFlexion.stDevValue, comparisonModel.newerRunningReport.peakKneeFlexion.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakKneeFlexion.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Peak knee flexion is the maximum bending of the knee during stance phase, and is another measure to gauge how much your body is sinking into the ground.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Hip Adduction
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakHipAdduction.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakHipAdduction.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-20, 20, comparisonModel.newerRunningReport.peakHipAdduction.avgValue, comparisonModel.newerRunningReport.peakHipAdduction.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-20, 20, comparisonModel.newerRunningReport.peakHipAdduction.avgValue, comparisonModel.newerRunningReport.peakHipAdduction.stDevValue, comparisonModel.newerRunningReport.peakHipAdduction.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipAdduction.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-20, 20, comparisonModel.newerRunningReport.peakHipAdduction.avgValue, comparisonModel.newerRunningReport.peakHipAdduction.stDevValue, comparisonModel.newerRunningReport.peakHipAdduction.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipAdduction.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-20</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Adduction (º)</div>
              <div class="cs_bpar-mark-right">Abduction (º)</div>
              <p class="cs_pbar_description after_annotation">
                Peak hip adduction is the maximum hip movement toward the midline of the body and the femur bones get closer together.
                This is an important part of absorbing forces, but excessive motion can put increased strain on the body.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Hip IR
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakHipIr.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakHipIr.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 20, comparisonModel.newerRunningReport.peakHipIr.avgValue, comparisonModel.newerRunningReport.peakHipIr.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 20, comparisonModel.newerRunningReport.peakHipIr.avgValue, comparisonModel.newerRunningReport.peakHipIr.stDevValue, comparisonModel.newerRunningReport.peakHipIr.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipIr.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 20, comparisonModel.newerRunningReport.peakHipIr.avgValue, comparisonModel.newerRunningReport.peakHipIr.stDevValue, comparisonModel.newerRunningReport.peakHipIr.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipIr.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Internal Rotation (º)</div>
              <div class="cs_bpar-mark-right">External Rotation (º)</div>
              <p class="cs_pbar_description after_annotation">
                Peak hip internal rotation (IR) is the maximum amount of hip rotation inwards toward the midline of the body.
                This is an important part of absorbing forces, but excessive motion can put increased strain on the body.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Contralateral
                    Pelvic Drop
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakContralateralPelvicDrop.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakContralateralPelvicDrop.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 15, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.avgValue, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 15, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.avgValue, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.stDevValue, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakContralateralPelvicDrop.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 15, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.avgValue, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.stDevValue, comparisonModel.newerRunningReport.peakContralateralPelvicDrop.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakContralateralPelvicDrop.rawValueRight}}</span>
                  <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Hip Hike (º)</div>
              <div class="cs_bpar-mark-right">Hip Drop (º)</div>
              <p class="cs_pbar_description after_annotation">
                Peak contralateral pelvic drop is the lateral pelvic angle during stance phase, and is often seen in association with excessive hip, knee, and ankle collapse.
                It is often debated whether this excessive collapse is generated from the bottom down (i.e. the hip drop causes changes in the joints below) or from the bottom up (i.e. the lower joint weakness causes changes in the joints above)
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Forward Lean Angle at Mid-Stance
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.forwardLeanAngle.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.forwardLeanAngle.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 12, comparisonModel.newerRunningReport.forwardLeanAngle.avgValue, comparisonModel.newerRunningReport.forwardLeanAngle.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 12, comparisonModel.newerRunningReport.forwardLeanAngle.avgValue, comparisonModel.newerRunningReport.forwardLeanAngle.stDevValue, comparisonModel.newerRunningReport.forwardLeanAngle.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.forwardLeanAngle.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 12, comparisonModel.newerRunningReport.forwardLeanAngle.avgValue, comparisonModel.newerRunningReport.forwardLeanAngle.stDevValue, comparisonModel.newerRunningReport.forwardLeanAngle.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.forwardLeanAngle.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">12</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Forward lean angle measures how far forward or backwards you lean during running.
                <br />
              </p>
            </div>
            <!--  -->
            
          </div>

          <hr class="cs_page-break" />
          <!-- page 5 -->
          <div class="card card-body">
            <!--  -->
            <h3 class="text-center factor_section">TERMINAL STANCE</h3>
            <div class="cs_separator_gray"></div>

            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Hip Extension
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.hipExtension.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.hipExtension.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-30, 0, comparisonModel.newerRunningReport.hipExtension.avgValue, comparisonModel.newerRunningReport.hipExtension.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-30, 0, comparisonModel.newerRunningReport.hipExtension.avgValue, comparisonModel.newerRunningReport.hipExtension.stDevValue, comparisonModel.newerRunningReport.hipExtension.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.hipExtension.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-30, 0, comparisonModel.newerRunningReport.hipExtension.avgValue, comparisonModel.newerRunningReport.hipExtension.stDevValue, comparisonModel.newerRunningReport.hipExtension.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.hipExtension.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-30</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">0</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Extension (º)</div>
              <div class="cs_bpar-mark-right">Flexion (º)</div>
              <p class="cs_pbar_description after_annotation">
                Hip extension is the straightening of the hip at the end of stance phase as the body moves forward.
              </p>
            </div>
            <!--  -->
            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Ankle Supination
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.ankleSupination.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.ankleSupination.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 15, comparisonModel.newerRunningReport.ankleSupination.avgValue, comparisonModel.newerRunningReport.ankleSupination.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 15, comparisonModel.newerRunningReport.ankleSupination.avgValue, comparisonModel.newerRunningReport.ankleSupination.stDevValue, comparisonModel.newerRunningReport.ankleSupination.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.ankleSupination.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 15, comparisonModel.newerRunningReport.ankleSupination.avgValue, comparisonModel.newerRunningReport.ankleSupination.stDevValue, comparisonModel.newerRunningReport.ankleSupination.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.ankleSupination.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                </div>
              </div>
              <div class="cs_bpar-mark-left">Supination (º)</div>
              <div class="cs_bpar-mark-right">Pronation (º)</div>
              <p class="cs_pbar_description after_annotation">
                Ankle supination occurs when your body pushes off to create a rigid lever at the foot.
              </p>
            </div>
            <!--  -->

            <h3 class="text-center factor_section">SWING</h3>
            <div class="cs_separator_gray"></div>

            <div class="cs_pbar-wrapper ">
              <div class="cs_pbar-item">
                <div class="cs_pbar-val">
                  <h3 class="cs_pbar-lable">
                    Peak Hip Flexion
                  </h3>
                  <span class="cs_middle cs_red">L&nbsp;{{comparisonModel.peakHipFlexion.leftDifferencePercentage}}%</span>
                  <span class="cs_middle cs_blue">R&nbsp;{{comparisonModel.peakHipFlexion.rightDifferencePercentage}}%</span>
                </div>
                <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 70, comparisonModel.newerRunningReport.peakHipFlexion.avgValue, comparisonModel.newerRunningReport.peakHipFlexion.stDevValue)}}">
                  <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 70, comparisonModel.newerRunningReport.peakHipFlexion.avgValue, comparisonModel.newerRunningReport.peakHipFlexion.stDevValue, comparisonModel.newerRunningReport.peakHipFlexion.deviationPointsLeft)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipFlexion.rawValueLeft}}</span>
                    <span>L</span>
                  </div>
                  <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 70, comparisonModel.newerRunningReport.peakHipFlexion.avgValue, comparisonModel.newerRunningReport.peakHipFlexion.stDevValue, comparisonModel.newerRunningReport.peakHipFlexion.deviationPointsRight)}}%">
                    <span>{{comparisonModel.newerRunningReport.peakHipFlexion.rawValueRight}}</span>
                    <span>R</span>
                  </div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                  <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">70</div>
                </div>
              </div>
              <p class="cs_pbar_description">
                Peak hip flexion during the swing phase has been linked to the rate at which the foot accelerates towards the ground at initial contact.
                If you are limited in hip flexion, it may change how you absorb forces on the ground.
              </p>
            </div>
            <!--  -->
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
